import * as React from 'react';
import { VIEWPORTS } from '@constants';

const SlideContext = React.createContext();

export const SlideDataProvider = (props) => {
    const { data, slideState, sectionsVisible, dispatch } = props;
    const { mobile: mobileConstant, desktop: desktopConstant } = VIEWPORTS;
    const { viewport, slideWidth } = slideState;

    const desktop = viewport === desktopConstant;
    const mobile = viewport === mobileConstant;

    const slideData = { 
      desktop,
      mobile,
      slideWidth, 
      viewport, 
      sectionsVisible, 
      data, 
      dispatch, 
      slideState 
    };

    return (
        <SlideContext.Provider value={slideData} {...props} />
    );
};

export const useSlideData = () => {
  const slideData = React.useContext(SlideContext);

  if (slideData === undefined) {
      throw new Error('useSlideData must be used within a SlideDataProvider');
  }

  return slideData;
};
